if (!customElements.get('collection-read-more')) {
  class CollectionReadMore extends HTMLElement {
    constructor() {
      super();

      this.button = null;
      this.label = null;
      this.beforeContent = null;
      this.config = {
        readMoreLabel: 'Read more',
        readLessLabel: 'Read less'
      };

      this.resizeObserver = null;
      this.handleClick = this.handleClick.bind(this);
      this.refresh = this.refresh.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('[data-read-more-button]');
      this.label = this.querySelector('[data-read-more-label]');
      this.beforeContent = this.querySelector('[data-before-content]');

      // Always start collapsed, including after Shopify theme-editor hot reloads.
      this.setExpandedState(false);

      if (!this.button || !this.label) return;

      const configElement = this.querySelector('[data-read-more-config]');

      if (configElement) {
        try {
          this.config = {
            ...this.config,
            ...JSON.parse(configElement.textContent)
          };
        } catch (error) {
          console.warn('Collection read more config could not be parsed.', error);
        }
      }

      this.button.addEventListener('click', this.handleClick);

      if ('ResizeObserver' in window && this.beforeContent) {
        this.resizeObserver = new ResizeObserver(this.refresh);
        this.resizeObserver.observe(this.beforeContent);
      }

      requestAnimationFrame(this.refresh);
    }

    disconnectedCallback() {
      if (this.button) {
        this.button.removeEventListener('click', this.handleClick);
      }

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    handleClick() {
      const isExpanded = !this.classList.contains('is-expanded');
      this.setExpandedState(isExpanded);
    }

    setExpandedState(isExpanded) {
      this.classList.toggle('is-expanded', isExpanded);
      this.classList.toggle('is-collapsed', !isExpanded);

      if (this.button) {
        this.button.setAttribute('aria-expanded', String(isExpanded));
      }

      if (this.label) {
        this.label.textContent = isExpanded
          ? this.config.readLessLabel
          : this.config.readMoreLabel;
      }
    }

    refresh() {
      if (!this.button || !this.label) return;

      const hasExtraContent = Boolean(
        this.querySelector('[data-read-more-extra]')
      );

      const beforeBlocks = this.beforeContent
        ? Array.from(
            this.beforeContent.querySelectorAll(
              '.metafield-rich_text_field > *'
            )
          )
        : [];

      const hasHiddenBeforeBlocks = beforeBlocks.length > 2;
      const previewBlock = beforeBlocks.length > 1
        ? beforeBlocks[1]
        : beforeBlocks[0];

      const previewIsClamped = previewBlock
        ? previewBlock.scrollHeight > previewBlock.clientHeight + 1
        : false;

      const shouldShowButton =
        hasExtraContent ||
        hasHiddenBeforeBlocks ||
        previewIsClamped;

      this.classList.toggle('has-overflow', shouldShowButton);
      this.button.hidden = !shouldShowButton;

      if (!shouldShowButton) {
        this.setExpandedState(false);
        return;
      }

      const isExpanded = this.classList.contains('is-expanded');
      this.setExpandedState(isExpanded);
    }
  }

  customElements.define('collection-read-more', CollectionReadMore);
}
